/* src/components/reconcile-transaction/reconcile-transaction.component.scss */
.content {
  background: var(--background);
  max-height: calc(var(--height) * 0.9);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.content .heading {
  padding: 5px;
}
.content table {
  width: 100%;
  background: rgba(var(--ion-color-dark-rgb), 0.1);
}
.content table td,
.content table th {
  padding: 5px;
  border: 1px solid black;
}
.content .selected {
  background: rgba(var(--ion-color-dark-rgb), 0.2);
}
.content .date-range {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.content .date-range .date {
  padding: 5px;
}
.content .date-range .date span {
  padding: 5px;
  font-weight: bold;
}
.content .buttons {
  padding: 5px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.green {
  color: var(--ion-color-success);
}
.red {
  color: var(--ion-color-danger);
}
/*# sourceMappingURL=reconcile-transaction.component.css.map */
